<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="人员删除"
      :save-func="()=>{}"
      @create-opened="onCreateOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="index-tree-box">
          <div class="left-box" style="height: calc(100vh - 148px);">
            <div class="left-title">
              <el-checkbox
                v-model="allCheck"
                :indeterminate="isIndeterminate"
                @change="allChange"
              >设备列表</el-checkbox>
            </div>
            <div class="left-main">
              <div class="chkitem" v-for="(i,key) in device_list" @change="deviceChange" :key="key">
                <el-checkbox v-model="i.Checked">{{i.DeviceName}}</el-checkbox>
              </div>
            </div>
          </div>
          <div class="right-box" style="padding: 0;border: none;">
            <div class="row-head right-head">待删除人员信息</div>
            <div class="filter-container">
              <el-row class="filter-top" type="flex" justify="end">
                <el-col :span="isMB?11:16">
                  <span class="span-top-text" style="line-height:39px;">查询条件</span>
                  <div class="searchIcon" @click="showForm = !showForm">
                    <i :class="showForm?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                  </div>
                </el-col>
                <el-col :span="isMB?13:8">
                  <div class="btn-search">
                    <el-button type="primary" icon="el-icon-search" @click="onQuery()">搜索</el-button>
                    <el-button type="primary" plain @click="resetQuery">重置</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row v-show="showForm">
                <el-divider style="margin:0px;"></el-divider>
                <el-form label-width="85px" class="form-item" :class="{'form-item-left':isMB}">
                  <el-form-item label="人员编号">
                    <el-input v-model="params.MemberNumber" placeholder="请输入人员编号" />
                  </el-form-item>
                  <el-form-item label="人员姓名">
                    <el-input v-model="params.MemberName" placeholder="请输入人员姓名" />
                  </el-form-item>
                  <el-form-item label="人员类型">
                    <el-select v-model="params.MemberType" placeholder="请选择人员类型" clearable>
                      <el-option label="学生" :value="0"></el-option>
                      <el-option label="教职人员" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="年级">
                    <el-select v-model="params.GradeId" placeholder="请选择年级" clearable>
                      <el-option label="高一" :value="1"></el-option>
                      <el-option label="高二" :value="2"></el-option>
                      <el-option label="高三" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="班级">
                    <el-select v-model="params.ClassId" placeholder="请选择班级" clearable>
                      <template v-for="(i,key) in class_list">
                        <el-option :key="key" :label="i.ClassName" :value="i.ClassId"></el-option>
                      </template>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="部门">
                    <tree-select
                      ref="treeSelect"
                      parent-select
                      :props="dpProps"
                      :options="dp_list"
                      @node-select="(x)=>{params.DpNames=x?x.DpName:null}"
                    />
                  </el-form-item>
                </el-form>
              </el-row>
            </div>
            <div ref="tbcontent">
              <div class="row-head right-tb-head">
                <span>待删除人员</span>
                <div style="float: right;">
                  <el-button type="primary" @click="onCreate" icon="el-icon-plus">添加</el-button>
                  <el-button type="danger" @click="onDelete">删除</el-button>
                </div>
              </div>
              <el-table :data="data" border :row-class-name="rowClass" @selection-change="onSelect">
                <el-table-column type="selection" width="45" align="center" />
                <el-table-column prop="MemberNumber" label="人员编号" />
                <el-table-column prop="MemberName" label="人员姓名" />
                <el-table-column prop="Grade" label="年级" />
                <el-table-column prop="ClassName" label="班级" />
                <el-table-column prop="DpNames" label="部门" />
                <el-table-column prop="MemberType" label="人员类型">
                  <template slot-scope="{row}">
                    <span v-if="row.MemberType==0">学生</span>
                    <span v-else>教职人员</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">确 定</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <member-dialog ref="memberDialog" @select-multiple="setMember" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import treeSelect from "@/components/common/treeSelect";
import memberDialog from "./memberDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    treeSelect,
    memberDialog,
  },
  data() {
    return {
      data: [],
      params: {
        MemberName: "",
        MemberNumber: "",
        MemberType: null,
        DpNames: "",
        GradeId: null,
        ClassId: null,
      },
      allCheck: false,
      isIndeterminate: false,
      selectRows: [],
      device_list: [],
      isMB: this.$store.state.isMB,
      showForm: !this.$store.state.isMB,
      api: require("@/api/cp/sendlog").default,
      device_api: require("@/api/cp/device").default,
      class_api: require("@/api/ed/class").default,
      grade_api: require("@/api/ed/grade").default,
      dp_api: require("@/api/ent/dp").default,
      class_list: [],
      grade_list: [],
      dp_list: [],
      dpProps: {
        // 配置项（必选）
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      LogType: 0, //人员下发日志 - 照片/白名单
      // tbHeight: 0,
      // tbContent: 0,
    };
  },
  // computed: {
  //   tbcontent() {
  //     if (this.showForm) return "height: calc(100% - 156px);";
  //     else return "height: calc(100% - 102px);";
  //   },
  // },
  watch: {
    // showForm() {
    //   console.log("height", this.$refs.tbcontent.clientHeight);
    //   this.tbHeight = this.$refs.tbcontent.clientHeight - 41;
    // },
    "params.GradeId": {
      handler() {
        this.params.ClassId = null;
        if (this.params.GradeId) {
          var info = JSON.parse(localStorage.getItem("loginInfo"));
          var params = { TermId: info.TermId, GradeId: this.params.GradeId };
          this.class_api.list(params).then((res) => {
            this.class_list = res.Data;
          });
        } else {
          this.class_list = [];
        }
      },
    },
  },
  methods: {
    onCreateOpened(data) {
      console.log("data", data);
      if (data) this.LogType = data.LogType;
      this.device_api.list({ DeviceType: 0 }).then((res) => {
        if (res.Data) {
          this.device_list = res.Data.map((x) => {
            return { ...x, Checked: false };
          });
        }
      });
      // console.log("tbcontent", this.$refs.tbcontent.clientHeight);
      // this.tbHeight = this.$refs.tbcontent.clientHeight - 41;

      // this.grade_api.list({}).then((res) => {});
      this.dp_api.list({}).then((res) => {
        this.dp_list = this.$commonJs.toTreeData(res.Data, "DpId");
      });
    },
    onQuery() {
      this.data.forEach((x) => (x.Checked = false));
      let arr = this.data;
      // 通过遍历key值来循环处理
      Object.keys(this.params).forEach((key) => {
        if (this.params[key] !== null && this.params[key] !== "") {
          if (typeof this.params[key] == "number") {
            arr = arr.filter((x) => x[key] == this.params[key]);
          } else {
            arr = arr.filter((x) => x[key].indexOf(this.params[key]) > -1);
          }
        }
      });
      arr.forEach((x) => (x.Checked = true));
    },
    resetQuery() {
      this.params.MemberName = "";
      this.params.MemberNumber = "";
      this.params.MemberType = null;
      this.params.DpId = null;
      this.params.GradeId = null;
      this.params.ClassId = null;
      this.$refs.treeSelect.clearHandle();
      this.data.forEach((x) => (x.Checked = false));
    },
    rowClass({ row, rowIndex }) {
      if (row.Checked) return "select-row";
      return "";
    },
    onCreate() {
      this.$refs.memberDialog.open().then((that) => {
        that.init(this.data, this.LogType, true);
      });
    },
    setMember(data) {
      console.log("setMember", JSON.parse(JSON.stringify(data)));
      this.data = [];
      data.forEach((x) => this.data.push({ ...x, Checked: false }));
    },
    onSelect(rows) {
      this.selectRows = rows;
      console.log("select", this.selectRows);
    },
    onDelete() {
      if (this.selectRows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.selectRows.forEach((x) => {
        var index = this.data.indexOf(x);
        this.data.splice(index, 1);
      });
    },
    allChange() {
      this.device_list.forEach((e) => {
        e.Checked = this.allCheck;
      });
      this.isIndeterminate = false;
    },
    deviceChange() {
      var num = 0;
      this.device_list.forEach((e) => {
        if (e.Checked) {
          num++;
        }
      });
      this.allCheck = num == this.device_list.length;
      this.isIndeterminate = num > 0 && num < this.device_list.length;
    },
    save() {
      if (this.data.length == 0) {
        this.$message.warning("请添加待删除人员");
        return;
      }
      var device = this.device_list.filter((x) => x.Checked == true);
      if (device.length == 0) {
        this.$message.warning("请选择设备");
        return;
      }
      var save_list = [];
      device.forEach((d) => {
        this.data.forEach((x) => {
          var item = {
            DeviceId: d.DeviceId,
            MemberType: x.MemberType,
            MemberId: x.MemberId,
            SendLogType: 1,
          };
          //照片
          if (this.LogType == 0) {
            item = { ...item, SendStatus: 0, WhiteListStatus: 2 };
          }
          //白名单
          if (this.LogType == 1) {
            item = { ...item, SendStatus: 2, WhiteListStatus: 0 };
          }
          save_list.push(item);
        });
      });
      console.log("保存", JSON.parse(JSON.stringify(save_list)));
      this.$refs.dialog.isLoading = true;
      this.api.saveList(save_list).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success("保存成功");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      this.data = [];
      this.device_list = [];
      this.selectRows = [];
      this.isIndeterminate = false;
      this.allCheck = false;
    },
  },
};
</script>
<style lang="scss">
.index-tree-box {
  .left-main {
    .chkitem {
      line-height: 28px;
      padding-left: 12px;
      .el-checkbox {
        .el-checkbox__label {
          width: 222px;
          overflow: hidden;
          vertical-align: text-bottom;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .right-head {
    font-size: 16px;
    padding-left: 10px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
  }
  .right-tb-head {
    border: 1px solid #e4e7ed;
    border-bottom: none;
    padding: 0 5px 0 10px;
  }
}
.select-row {
  background-color: #f0f9eb !important;
}
.left-title {
  padding-left: 12px !important;
  .el-checkbox__label {
    font-size: 16px;
    vertical-align: text-top;
  }
}
</style>